
export interface ITable
{
	[key: string]: string,
}
